import { render, staticRenderFns } from "./control-preview.vue?vue&type=template&id=7f2b9606&scoped=true&"
import script from "./control-preview.vue?vue&type=script&lang=js&"
export * from "./control-preview.vue?vue&type=script&lang=js&"
import style0 from "./control-preview.vue?vue&type=style&index=0&id=7f2b9606&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b9606",
  null
  
)

export default component.exports